interface ActionButton {
  label: string;
  icon: string;
  primary?: boolean;
}

export default function DocumentActions({ actions }: { actions: ActionButton[] }) {
  return (
    <div className="flex items-center justify-center gap-3 flex-wrap">
      {actions.map((a) => (
        <button
          key={a.label}
          className={`px-5 py-2.5 text-sm font-bold rounded-lg transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2 ${
            a.primary
              ? 'bg-ink-700 text-white hover:bg-ink-600'
              : 'text-ink-600 border border-ink-200 hover:bg-cream-50'
          }`}
        >
          <i className={`${a.icon} text-base`} />
          {a.label}
        </button>
      ))}
    </div>
  );
}